export enum CookieKey {
  CookiePolicyDismissed = 'cpd',
}
